import { getApiData, getApiDataWith403Handling } from "./APIHelper";
import { Setting } from "./Setting";
import { store } from "../redux/store/configureStore";
import authActions from "../redux/reducers/auth/actions";
import SingleMilestoneAccordion from "../components/SingleMilestoneAccordian";
import moment from "moment";
import { ReactComponent as DhiramIcon } from "../assets/svg/DhiramIcon.svg";
import { 
  formatAmountWithCurrency, 
  getFormattedAmountWithoutCurrency,
  getCurrentCurrencyLocale 
} from "./CurrencyUtils";

export const updateUserData = async () => {
  const { setUserData } = authActions;

  try {
    const response = await getApiDataWith403Handling(
      Setting.endpoints.me,
      "GET",
      {}
    );
    console.log("res1", response);

    if (!response.success && response.message === "Forbidden") {
      console.log("403 Detected", response);
    } else if (response.success) {
      store.dispatch(setUserData(response?.data));
      return response?.data;
    }
  } catch (error) {
    console.log("API call failed:", error);
  }
};

export function renderMilestones(milestones, handleRowClick) {
  const allMilestones = [];
  for (let key in milestones) {
    allMilestones.push(
      <SingleMilestoneAccordion
        milestone={milestones[key]}
        id={key}
        handleRowClick={handleRowClick}
      />
    );
  }
  return allMilestones;
}

export function removeEmptyKeys(obj) {
  if (Array.isArray(obj)) {
    return obj
      .map((item) => removeEmptyKeys(item))
      .filter(
        (item) =>
          item !== null &&
          (typeof item !== "object" ||
            Object.keys(item).length > 0 ||
            item instanceof File)
      );
  } else if (typeof obj === "object" && obj !== null) {
    let newObj = {};
    if (obj instanceof File) {
      newObj = obj;
    } else {
      Object.keys(obj).forEach((key) => {
        const value = removeEmptyKeys(obj[key]);
        if (
          value !== null &&
          (typeof value !== "object" || Object.keys(value).length > 0)
        ) {
          newObj[key] = value;
        }
      });
    }
    return newObj;
  }
  return obj;
}

export const transformDateFormat = (date) => {
  return moment(date)?.format("MMM DD, yyyy");
};

export const transformAmount = (amount) => {
  // Use new currency utility for backward compatibility
  return formatAmountWithCurrency(amount, 'default');
};

export function formattedAmount(amount) {
  console.log("amount", amount);
  // Use new currency utility with default icon type
  return formatAmountWithCurrency(amount, 'default');
}

export function formattedAmountWithoutAed(amount) {
  // Use new currency utility for formatting without currency symbol
  return getFormattedAmountWithoutCurrency(amount);
}

/**
 * Format an integer amount with international thousands separators.
 * Accepts string or number; returns "" for empty/invalid input.
 * Strips any non-digit chars before formatting (e.g. existing commas).
 */
export function formatIntegerAmount(value) {
  if (value === null || value === undefined || value === "") return "";
  const digits = String(value).replace(/[^\d]/g, "");
  if (!digits) return "";
  const n = Number(digits);
  if (!Number.isFinite(n)) return "";
  try {
    return new Intl.NumberFormat("en-AE").format(n);
  } catch {
    return digits;
  }
}

/**
 * Strip all non-digit characters from a value (e.g. user-typed commas)
 * and return the resulting digit-only string.
 */
export function parseIntegerAmount(value) {
  if (value === null || value === undefined) return "";
  return String(value).replace(/[^\d]/g, "");
}

export function newFormattedAmount(amount) {
  // Use new currency utility with default icon type
  return formatAmountWithCurrency(amount, 'default');
}

export const getImageSrc = (imagePath) => {
  const baseUrl = "https://renohome.blob.core.windows.net/";
  const defaultImage = `${baseUrl}reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b`;

  try {
    if (imagePath) {
      return imagePath.startsWith(baseUrl)
        ? imagePath
        : `${baseUrl}${imagePath}`;
    }
    return defaultImage;
  } catch (error) {
    console.error("Error parsing image path:", error);
    return defaultImage;
  }
};
